import { SendPasswordResetEmail } from 'domain/usecases/send-password-reset-email';
import { BaseHttpService } from 'main/factories/http';

export class RemoteSendPasswordResetEmail
  extends BaseHttpService<SendPasswordResetEmail.Model>
  implements SendPasswordResetEmail
{
  async sendPasswordResetEmail(params: SendPasswordResetEmail.Params): Promise<SendPasswordResetEmail.Model> {
    const payload = {
      email: params.email,
    };

    await this.request('post', payload);
    return { status: 'success' };
  }
}
